var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Find_Duplicate"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Find_Duplicate",
    "data-name": "Find Duplicate",
    clipPath: "url(#clip-Find_Duplicate)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    transform: "translate(4 4)",
    fill: "#272d55",
    stroke: "#272d55",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.534,
    height: 14.124,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8.534,
    height: 13.124,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_30",
    "data-name": "Subtraction 30",
    transform: "translate(15.959 16.124) rotate(180)",
    fill: "#272d55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.53380012512207 13.62370014190674 L 0.9998999834060669 13.62370014190674 C 0.7242500185966492 13.62370014190674 0.5 13.39945030212402 0.5 13.12380027770996 L 0.5 0.9999000430107117 C 0.5 0.8211750984191895 0.594268262386322 0.664061427116394 0.7357000112533569 0.5756669044494629 L 0.7357000112533569 11.93220043182373 C 0.7357000112533569 12.75924968719482 1.408550024032593 13.43210029602051 2.235599994659424 13.43210029602051 L 8.927060127258301 13.43210029602051 C 8.835461616516113 13.54868507385254 8.693227767944336 13.62370014190674 8.53380012512207 13.62370014190674 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.53380012512207 14.12370014190674 L 0.9998999834060669 14.12370014190674 C 0.4485499858856201 14.12370014190674 -5.340576869627967e-09 13.67514991760254 -5.340576869627967e-09 13.12380027770996 L -5.340576869627967e-09 0.9999000430107117 C -5.340576869627967e-09 0.4485500752925873 0.4485499858856201 7.095336940210473e-08 0.9998999834060669 7.095336940210473e-08 L 1.235700011253357 7.095336940210473e-08 L 1.235700011253357 11.93220043182373 C 1.235700011253357 12.48355007171631 1.684249997138977 12.93210029602051 2.235599994659424 12.93210029602051 L 9.533699989318848 12.93210029602051 L 9.533699989318848 13.12380981445312 C 9.533699989318848 13.67514991760254 9.085149765014648 14.12370014190674 8.53380012512207 14.12370014190674 Z",
    stroke: "none",
    fill: "#272d55"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(6.2 14.4)",
    fill: "#aecdfc",
    fontSize: 9,
    fontFamily: "HelveticaRounded-Bold, Helvetica Rounded",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindDuplicate);
export default __webpack_public_path__ + "static/media/FindDuplicate.5a8a6bc40864b4f0c69c6a7ff4a9b331.svg";
export { ForwardRef as ReactComponent };